<template>
<div class="container-fluid">

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="far fa-newspaper mr-2" aria-hidden="true"></i>RIEPILOGO ORDINI FORNITORE</h4>
  </div> 

 <div class="card-body"> 
  
 <div class="row">
 <div  v-if="items.length==0" class="col-md-4"> 

<div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="filter" v-on:submit.prevent="submit()">
    
    

    <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
    <collection-select v-bind:props="collection" @update="setCollectionId"></collection-select> 
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
    
    <!--  
      <span><strong>Tipo raggruppamento</strong></span>  
       <div  v-for="(item,index) in grouping" :key="index">  
        <div class="form-check">
          <input type="radio" class="form-check-input" :id="'group_by_' + index" :value="index" v-model="group_by">
          <label class="form-check-label"  :for="'group_by_' + index">{{item.group_by}}</label>
        </div>
       </div>
    -->
    <div class="form-check form-check-inline">
    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="0" v-model="typeId" @change="setTypeId(typeId)">
      <label class="form-check-label" for="inlineRadio1">     
        <strong>ORDINATO/CONSEGNATO</strong></label>
    </div>

    <div class="form-check form-check-inline ">
    <input class="form-check-input " type="radio" name="inlineRadioOptions" id="inlineRadio2" value="1" v-model="typeId" @change="setTypeId(typeId)">
      <label class="form-check-label" for="inlineRadio2">
        <strong>SOLO ORDINATO ANCORA DA CONSEGNARE</strong>        
      </label>
    </div>


   <div class="card-footer bg-transparent border-info"> 
   <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
   <button type="submit" :disabled="spinner"  class="btn btn-primary float-right">
    <i class="far fa-play-circle  mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
     </button>           


  </div>
  </form>
 
  </div>
</div>

 </div>


<div v-else class="col">
  <h4 class="card-title">
    <strong>
    {{ supplier.name  }}  {{ collection.name  }} {{ department.name }} {{ type }}
    </strong>
  </h4>
  <button v-if="items.length>0"  @click="items=[],row_total=[]" type="button"  class="btn btn-secondary mb-1 mr-3">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button> 

  <button :disabled="items.length==0 || spinner_pdf == true" @click="htmlToPDF()" type="button"   class="btn btn-primary mb-1 ">
    <i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button>  
  <div v-if="progress>0" class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
          {{ progress }}%
        </div>
  </div>




  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-bordered table-hover table-sm mb-0">
    <thead >
      <tr class="table-primary">

       
       <!-- <th scope="col">Anno</th>-->
       <th scope="col">ORDINE</th>
        <th scope="col">BRAND</th>
        <th scope="col">REPARTO</th>
        <th scope="col">CATEGORIA</th>
        
        <th scope="col">STAGIONE</th>
        
        <th class="text-right" scope="col">ORDINATO</th>        
        <th class="text-right" scope="col">CONSEGNATO</th>
                
        <th class="text-right text-nowrap" scope="col">ORDINATO €</th>
        <th class="text-right text-nowrap" scope="col">CONSEGNATO €</th>
        <th></th>
              
      </tr>
    </thead>
    <tbody>
      <tr :style="{color:setColor(item) ,fontSize: setFontSize(item),fontWeight:setFontWeight(item)}"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">

        <td>{{item.order_data}}</td>
        <td>{{item.brand}}</td>   
        <td>{{item.department}}</td>                        
        <td>{{item.category}}</td>
        
        <td>{{item.season}} {{ item.season_year }}</td>
        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td :style ="{color:item.total2_qty == 0 && item.brand != null && item.department != null ? 'red':''}"  class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
        <td>
          <button  v-if="item.category != null" class="btn btn-link btn-sm text-nowrap" @click="getDataPDF(item)" href="#">
      <i style="color : blueviolet" class="fas fa-file-export mr-2" aria-hidden="true"></i>
      </button>
<!--
          <div class="dropdown">
  <button v-if="item.supplier != 'Totale'" style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
    <i class="fas fa-cog mr-2" aria-hidden="true"></i>
    Opzioni
  </button>
          <div class="dropdown-menu ">
    <a class="dropdown-item" @click="getDataPDF(item,'row')" href="#">
      <i style="color:brown" class="far fa-file-alt mr-2" aria-hidden="true"></i>
      ESPORTA PDF</a>

    
   
  </div>
  </div>
-->
        </td>
               
      </tr> 
    </tbody>
    <tfoot>
        <tr data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        
        <td> </td>
        <td> </td>
        <td> </td>
        <td> </td>
        <td></td>
        
        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
        <td></td>
        
        
        </tr>   
    </tfoot>    
  </table>

</div>

 

</div>  

</div>

</div>

</div>

</div>

</template>
<script>
//import axios             from "axios";
import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'

import jsPDF             from 'jspdf';
import fmt               from '@/components/mixins/fmt.js'

import collectionSelect from '@/components/common/CollectionSelect_1.vue'

export default {
  mixins:[fmt], 
  components: {alertBox,supplierSelect,departmentSelect,collectionSelect},
  data() {
    return {
      progress        : 0,
      typeId          : "0",
      type            : 'ORDINATO/CONSEGNATO',
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        name          : ''

      },
      store           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true,
        name          : ''


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        name          : ''
       
      },

        collection  : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1,
        name          : ''

      },
    
      
      
      data1           : null,
      data2           : new Date().toISOString().slice(0,10),
      
      
      
      spinner         : false,
      spinner_pdf     : false,
      

      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      grouping        : [],
      group_by        : 0
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
    getProgress()
  {
    let p = this.progress
    return p + "%";
  }
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    this.getGrouping()
  },
  methods: {
   
    
   setCollectionId(Id,e)   
   { 
      this.collection.Id = Id
      this.collection.name = e.target.options[e.target.options.selectedIndex].text
      
   }, 
   setTypeId(Id) 
   {
    this.type = Id == '0' ? 'ORDINATO/CONSEGNATO' : 'SOLO ORDINATO ANCORA DA CONSEGNARE'
    
   }, 
   setColor(item)
   {
       let color = 'black'
      

       if(item.category == null )
       {
           color = 'blue'
       }

       
       if(item.category == null && item.department == null)
       {
           color =  'green'
       }

       return color

   },
   setFontSize(item)
   {
    let fontSize = '14px'
    if(item.category == null )
       {
           fontSize = '18px'
       }
       if(item.category == null && item.department == null)
       {
           fontSize = '22px'
       }
       
       return fontSize
   },
   setFontWeight(item)
   {
    let fontWeight = 'normal'
    if(item.category == null)
    {
      fontWeight = 'bold'
    }
    return fontWeight
   },
   async exportToPDF(sp_name,item,type)
   {
        
      this.spinner_pdf = true
      const sp         = {'sp' : sp_name}
      const data       = {
        'orderId'      : item.orderId,
        'supplierId'   : item.supplierId,
        'brand'        : item.brand,
        'seasonId'     : item.seasonId,
        'season_year'  : item.season_year,
        'departmentId' : item.departmentId,
        'categoryId'   : item.categoryId,
        'typeId'       : this.typeId 
      }

      const json  = Object.assign(data, sp)     
      //this.spinner = true      
      await api.post(json).then(res => {
         
          if(res.status==200)
            {

              this.printPDF(res.data.recordsets[0],type)
            
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner_pdf = false
        });
      
 

    


   }, 

   getDataPDF(item)
   {
      
                
      const obj = item
      const sp = 'spOrderSupplierRowDetailPDF'
      this.exportToPDF(sp,obj)  
   },

   
    setSupplierId(supplierId,text)
    {        
      this.supplier.Id = supplierId
      
      this.supplier.name = text  
    },  
    setDepartmentId(departmentId,e)
    {
      this.department.Id        = departmentId
      this.department.name = ''
      
      if(departmentId>0)
      {
        
        this.department.name = e.target.options[e.target.options.selectedIndex].text
      }
    },
    /*
    setSeasonId(seasonId,e)
    {           
      this.season.Id       = seasonId
      this.season.name     = e.target.options[e.target.options.selectedIndex].text
      
    },
    */
   /*      
    setYear(year,e)
    {
      this.season_year.year = year
      
    },
    */


    submit() 
    {
      
      this.getData()
    },  
    
    async getGrouping()
    {
      this.grouping = []
      var json        = {'sp' : 'spGrouping'}
      
      this.spinner  = true
      await api.post(json).then(res => {
        
            if(res.status==200)
            { 
              this.grouping = res.data.recordsets[0]
            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            }
            else
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1
            }

            }).catch(err => 
          {
	            
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1

          }).finally(() => {
              this.spinner = false
          });


    },

       
    
    async getData() {
      
      this.row_total = []
      this.items     = []
      this.msg.title = ''
            
      var sp = {'sp' : 'spOrdersTotal'}           
     
      var data  = {
        'supplierId' :this.supplier.Id,
        
        'departmentId':this.department.Id /*'group_by':this.grouping[this.group_by]['group_id']*/,
        'typeId' : this.typeId,
        'collectionId' :this.collection.Id
      }
      var json  = Object.assign(data, sp)

      this.spinner = true
      
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0].filter(item => item.brand != null)
              this.row_total = res.data.recordsets[0].filter(item=>item.brand == null)
            
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    },



async  htmlToPDF()
    {
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }

      const addFooters = doc => {
          const pageCount = doc.internal.getNumberOfPages()
          doc.setFont('helvetica', 'italic')
          doc.setFontSize(8)
          for (var i = 1; i <= pageCount; i++) 
          {
            doc.setPage(i)

            doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
            align: 'center'})
          }
      }
       

      this.spinner_pdf = true
      await wait(0) 
      const doc = new jsPDF(
      {
         orientation: "landscape",
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.setFontSize(12)
      doc.text("RIEPILOGO SINTETICO ORDINI FORNITORE " + this.supplier.name  + " COLLEZIONE - " + this.collection.name +  ' - ' + this.department.name +  " del " + n + ' ' + t , 15, 10);
      doc.setFontSize(8)
      doc.text(this.type , 15, 15);
      doc.setFontSize(10)
      //doc.text(this.pdf_title.season + '-' + this.pdf_title.year , 15, 15);
     
      doc.autoTable(
      
    
       { html       : '#my-table',
       margin       : {top:20},
       showFoot     : 'lastPage',
       theme        : 'grid',
     
        headStyles: {
          fillColor: [41, 128, 185], // blu
          textColor: 255,            // bianco
          fontStyle: 'bold',
          5: { halign: 'right' },
          6: { halign: 'right' },
          7: { halign: 'right' },
          8: { halign: 'right' },
        },

        footStyles   : {halign:'right',fontStyle:'bold',fillColor:'white',textColor:'black',fontSize: 14,cellWidth: 'wrap',},

        columnStyles : {   5: { halign: 'right' }, 6: { halign: 'right' }, 7: { halign: 'right' }, 8: { halign: 'right' } },
        
        
          didParseCell: function(data) {

                
           
            if ( data.row.cells[0].text == '') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 10
              

            }
                    
          }, 
        
        styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 8,
          }
        })
      
     
    addFooters(doc)
         
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    this.spinner_pdf = false
    
      
     
    },


  

    async printPDF(items)
    {
      
      
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
      
      let r = 0
      const last_row = 190
      let grandTotal_qty = 0
      let grandTotal1 = 0
      let grandTotal2 = 0

      // let items = this.detail
      
      const doc = new jsPDF('landscape')

      var page = 1
            
      var row_index    = 1
      
      const init_row     = 31
      var row          = init_row
      const row_header   = row -5

      const col          = 5
      const col1         = 20
      const col2         = 70
   
      const col3         = 220
      const col4         = 270
      const col5         = col3 
      
      const header = () =>  
      {
        
        var d = new Date();
        var n = d.toLocaleString();
        doc.setDrawColor(51,0,0)       
        doc.setFillColor(232,232,232)        
        doc.roundedRect(5, 5, 285, 16,2,2,'FD')        
        doc.setDrawColor(0)
        doc.setFontSize(14)
        doc.setFont("helvetica","bold");
        doc.text('LISTA PRODOTTI ORDINE '  ,  150, 10, null, null, "center");
        doc.setTextColor(14, 161, 0); 
        doc.text(this.supplier.name + ' ' + this.collection.name + ' '  + this.department.name + ' ' + this.type ,  150, 17, null, null, "center");
       
       

        doc.setTextColor(0, 0, 0); 
                     
        doc.setFontSize(10)
        doc.setTextColor(0, 0, 255);
        doc.text('BRAND', col1,row_header);
        doc.text('PRODOTTO', col2,row_header);
        doc.text("TOTALE Q.TA ", col3, row_header,{align:'right'});
        doc.text("TOTALE VALORE €", col4  , row_header,{align:'right'});
        
        

        doc.setTextColor(0, 0, 0);        
        doc.setFont("helvetica","normal");

      }
      var footer = function(page,pages)
      {

        doc.setFont("helvetica","normal")
        doc.setTextColor(0, 0, 0)
        doc.setPage(page)
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  260, 200, null, null, "center");
       
      }

           
      header()  
      
      
      let j
      // MAIN LOOP
      
      let data       = items.filter(item => item.brand != 'zzzSubTotal')
      for (j = 0; j < data.length; j++) {
      
      let item = items[j]
             
        r++  
        this.progress = Math.round(r / items.length * 100)
        await wait(0) 
        if(item.category == 'SubTotal' && item.brand != 'zzzSubTotal')
        {
          grandTotal_qty += item.total_qty
          grandTotal1 += item.total1
          grandTotal2 += item.total2
        }

        
        doc.setFontSize(8)
       
        if(row > last_row )
        {
          page++  
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }                    
        }
        doc.setTextColor(0, 0, 0)

       
       
        if(item.category != 'SubTotal')
        {
            doc.text(row_index.toString(), col, row)    
        }
        

        doc.setFont("helvetica","bold")
        doc.setFontSize(10)     
        doc.setTextColor(0, 0, 0);
        
        doc.setFont("helvetica","bold")
        


        if(item.category == 'SubTotal')
        {
            doc.roundedRect(5, row-5, 285, 6  ,2,2)                
            doc.setTextColor(14, 161, 0);            
            doc.setFontSize(14)     
        }
        
        if(item.brand == 'zzzSubTotal')
        {
          item.brand = 'TOTALE ORDINE'
        }
            
        doc.text(item.brand.toString().substr(0,20), col1, row)
              
        let product = item.category.substr(0,item.category.indexOf("|"))
        doc.text(product.toString(), col2, row) 

        doc.text(this.fmt2(item.total_qty,0), col3 - 25, row,{align:'right'})
        doc.text(this.fmt2(item.deli_total_qty,0), col5, row,{align:'right'})
        

        doc.text(this.fmt1(item.total1,2), col4 , row,{align:'right'})
     
       
       doc.setTextColor(0, 0, 0);
       doc.setFont("helvetica","normal")

       row_index++ 
       row = row + 5

       if(row > last_row )
        {
          page++  
          
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }
        }

       let n = col + 18
       let w = 11.8 
       let cols = []

       

        let first_index = item.category.indexOf('|')
        let last_index = item.category.lastIndexOf('|') 
        
        if(first_index > 0 && last_index > 0)
        {
        let header = item.category.substr(first_index+1,(last_index-first_index)-1)
        cols =  JSON.parse(header)
        doc.setFontSize(8)  
        // HEADER COLS
        cols.forEach(col => {  
        doc.setFillColor(240,240,240)  
        doc.rect(n -1, row -3, w, 4,'FD');
        doc.text(col.size.toString().substr(0,6) , n, row);  
        
        n= n + w
        })
        
        }

        first_index = item.category.lastIndexOf('|')
        if(first_index >0)
        {
        let data = item.category.substr(first_index+1)      
        let colors = JSON.parse(data)       
        row = row + 5
        colors.forEach(color => {
        doc.setFontSize(8)  
        if(row > last_row )
        {
          page++  
          
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }                    
        }

        // COLOR
        doc.text(color.color.toString().substr(0,9) , 5, row )
        
        let sizes  = color.s
        n = col + 18

        // SIZES
        cols.forEach(col =>{
          sizes.forEach(size=>{
            doc.setDrawColor(200,200,200)       
            doc.rect(n -1, row -3, w, 4)
            doc.setDrawColor(0)       
            if(col.size == size.size) 
            { 
              if(size.qty != size.delivered_qty)
              {
                doc.text(size.qty.toString().substr(0,10) + ' / ' + size.delivered_qty.toString().substr(0,10) , n, row )  
              }
              else
              {
                doc.text(size.qty.toString().substr(0,10)  , n, row )
              }
              
              
              

            } 

          })
          n = n + w 
        })
                  
        row = row + 4
        
       })
    
       
       
       row = row + 4
    }      
    // END LOOP
    } 
      
      



      for (let i = 1; i <= page   ; i++) {
          footer(i,page)
      }
     

      this.progress = 0
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },



  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 700px;
overflow   : auto;
}
.pointer:hover
{
 
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

    
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2 !important;

    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {


  font-family  : 'Roboto Condensed';
    
    font-size    : 22px;
    font-weight  : bold;
    background   : white;
    color        : black;
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 30px;
    
    border-color  : white !important;
    border-top    : 2px solid #3f28a7 !important; 
    border-bottom : 2px solid #4128a7 !important;
    
 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
 
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.card-header
{
  height: 45px;
}

.table {
  border-collapse: separate;
}

</style>